import React from "react";
import moment from "moment";
import "moment/locale/es";

import { ChatProvider } from "./context/chat/ChatContext";
import { AuthProvider } from "./context/AuthContext";
import { AppRouter } from "./router/AppRouter";
import { SocketProvider } from "./context/SocketContext";

// Importar estilos globales
import "./index.css";

// For Saas import Saas.scss
import "./assets/scss/Saas.scss";

moment.locale("es");

/**
 * Aplicación principal
 * Las rutas de la aplicación están definidas en el componente AppRouter
 * y se encuentran envueltas en los contextos de autenticación y chat
 * así como en el contexto del socket
 *
 * @returns {React.Component} Aplicación principal
 */
export const MainApp = () => {
  return (
    <ChatProvider>
      <AuthProvider>
        <SocketProvider>
          <AppRouter />
        </SocketProvider>
      </AuthProvider>
    </ChatProvider>
  );
};
